import { render } from "./NewHome.vue?vue&type=template&id=aea96596"
import script from "./NewHome.vue?vue&type=script&lang=js"
export * from "./NewHome.vue?vue&type=script&lang=js"

import "./NewHome.vue?vue&type=style&index=0&id=aea96596&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__